// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eopoi-widget .poi-social-btn{border-radius:4px;padding-top:10px;padding-bottom:10px}.eopoi-widget .detail-back-button-row .detail-button-white{border:4px solid #a8c1c7;border-radius:4px;background:#fff!important;font-weight:700;box-shadow:none}.eopoi-app-detail-social .attachDiv.socialDiv{position:static;width:auto;display:inline-block}.eopoi-app-detail-social .v-menu__content.theme--light.menuable__content__active{width:200px}", ""]);
// Exports
module.exports = exports;
